import util from '@/utils/index'
import {
    setToken
} from '@/utils/user'
import dialog from '@/utils/dialog';
import store from '@/store/index'
// import EXIF from "exif-js";
// 起调原生功能
// funName 起调方法
// callName 原生环境回调方法
// params 起调参数
// data.onlyAndroid 是否仅限安卓环境调用
export function invoking(funName, callName, params, data = {}) {
    return new Promise((resolve) => {
        const u = navigator.userAgent,
            // 判断ios或安卓环境
            isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1,
            isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

        if (callName) {
            // 设置起调成功执行方法,这里直接异步回调
            window[callName] = function(data) {
                resolve && resolve(data);
            };
        }
        try {
            // console.log(isAndroid, isiOS, data.onlyAndroid)
            // 安卓环境
            if (isAndroid) {
                // 如果是对象，转换成字符串
                if (util.isObject(params)) {
                    params = JSON.stringify(params);
                }
                if (params) {
                    ZZBAndroidJavaScriptInterface[funName](params);
                } else {
                    ZZBAndroidJavaScriptInterface[funName]();
                }
            } // ios终端
            if (isiOS && !data.onlyAndroid) {
                window.webkit.messageHandlers[funName].postMessage(params);
            }
        } catch (error) {
            if (!store.state.isDev) {
                dialog.alert({
                    title: "出错了",
                    message: error
                });
            }
        }
    })
}

// 文件地址前缀
const ossUrl = 'https://www.zzbjr.cn/akfile/view/'
// 注意提醒app端上传域名是https://www.zzbjr.cn不然会出问题
// 这里没有做测试环境和正式环境的区分，直接用的正式的图片上传
// 起调原生照相功能
export function appChooseAndUpImage() {
    return new Promise((resolve) => {
        invoking('zzbAppShowPhotoAction', 'zzbAppShowPhotoCallBackWithString').then(res => {
            resolve(`${ossUrl}${res}`)
        });
    })
}

// 获取用户登录token
export function getToken() {
    return invoking('zzbAppToken', 'zzbAppCallBackToken');
}

// 微信支付
export function appWeiXinPay(params) {
    return invoking('zzbAppWeiXinPay', 'zzbAppCallBackWeiXinPay', params);
}

// 切换模式
export function nativeBack() {
    // 安卓端需要参数，此参数为预留参数
    return invoking('zzbAppSwitchFXSystem', null, '1');
}

// 切换到商城模式
export function appSwitchAMSystem() {
    // 安卓端需要参数，此参数为预留参数
    return invoking('zzbAppSwitchAMSystem');
}

// 用于告知安卓判断是否在主页面
export function appCurrentPosition(params) {
    // 安卓端需要参数，此参数为预留参数
    return invoking('zzbAppCurrentPosition', null, params, {
        onlyAndroid: true
    });
}

// 用于安卓拨打电话
export function appCallPhone(phone) {
    // 安卓端需要参数，此参数为预留参数
    return invoking('zzbAppCallPhone', null, {
        phone: phone
    }, {
        onlyAndroid: true
    });
}


// 使用外部浏览器打开链接
export function openUrl(url) {
    // 安卓端需要参数，此参数为预留参数
    invoking('zzbAppOpenBlankWebView', null, {
        urlString: url
    });
}

// 退出登录
export function appLoginout() {
    dialog
        .confirm({
            title: "提示",
            message: "是否确认退出？"
        })
        .then(() => {
            appQuietLoginout();
        });
}

// 静默退出登录
export function appQuietLoginout() {
    if (store.state.isDev) {
        setToken('');
    }
    invoking('zzbAppLoginout');
}
// 清除缓存
export function appClearWebViewCache() {
    invoking('zzbAppClearWebViewCache');
}

// 获取当前可以切换到那里
export function getNativeInfo() {
    // 安卓端需要参数，此参数为预留参数
    return invoking('zzbAppLoginData', 'zzbAppLoginDataCallBack');
}



// 处理图片，避免图片倒转
// export function processingImages(url) {
//     return new Promise((resolve) => {
//         const image = new Image();
//         image.crossOrigin = '';
//         image.src = url;
//         // image.src = "https://s.vipkidstatic.com/fe-static/mobile/learning-effect/prd/src/page/prd/img/common/bg@2x-2e6bf90fab2d77144cec052e5aa1766e.png"
//         // 加载图片
//         image.onload = function() {
//             // 获取图片角度信息
//             EXIF.getData(image, function() {
//                 const Orientation = EXIF.getTag(this, 'Orientation');
//                 let cls = ''
//                 // 如果角度偏移，则加上对应的旋转css处理，把图片转正
//                 if (Orientation && Orientation != 1) {
//                     // 图片角度不正确
//                     switch (Orientation) {
//                         case 6:
//                             cls = 'rotate90';
//                             break;
//                         case 3:
//                             cls = 'rotate180';
//                             break;
//                         case 8:
//                             cls = 'rotate_90';
//                             break;
//                         default:
//                             break;
//                     }
//                 }
//                 resolve(cls);
//             })
//         }
//     })
// }